import { Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { AppStoreDispatcher } from '../state/app.state.dispatcher';
import { doc, Firestore, getDoc } from '@angular/fire/firestore';
import { ProfileStateDispatcher } from '../state/profile/profile.dispatcher';
import { ApiService } from '../backend/api.service';

@Injectable({
    providedIn: 'root'
})
export class ConversationService {

    constructor(
        public cloudFNs: Functions,
        public appStateDispatch: AppStoreDispatcher,
        public firestore: Firestore,
        public profileDispatch: ProfileStateDispatcher,
        public apiService: ApiService,
        ) {}

    /**
     *  Load conversation info
     */
    public async loadConversation(conversationID: string): Promise < any > {
        const docReference = doc(this.firestore, `conversations/${conversationID}`)
        return getDoc(docReference).then(doc => {
            return doc.data();
        });
    }

    /**
     * Send message
     * @param conversationID The conversation's id
     * @param message The message content
     */
    public async sendMessage(conversationID: string, message: string): Promise < any > {
        // const myID = await this.profileDispatch.getMyID();
        // const timestamp = new Date().getTime();
        // const docReference = doc(this.firestore, `conversations/${conversationID}/messages/${timestamp}`);
        // return setDoc(docReference, {
        //         timestamp: timestamp,
        //         payload: message,
        //         senderID: myID
        //     })
        //     .then(() => {
        //         console.log('Document successfully written!');
        //         this.apiService.sendDirectMessage({ senderID: myID, conversationID: conversationID, message: message }).then(result => {
        //             console.log(result);
        //         }).catch(error => {
        //             console.log(error);
        //         });

        //         const docReference = doc(this.firestore, `conversations/${conversationID}`);
        //         return updateDoc(docReference, {
        //             details: {
        //                 lastTimestamp: timestamp,
        //                 lastMessage: message,
        //                 lastSenderID: myID
        //             }
        //         });
        //     })
        //     .catch(error => {
        //         console.error('Error writing document: ', error);
        //         return {
        //             success: false,
        //             error: error
        //         };
        //     });
    }

    /**
     *  Load messages
     */
    public async loadMessages(conversationID: string): Promise < any > {
    //     return this.firestore.collection(`conversations/${conversationID}/messages`).snapshotChanges().pipe(map(actions => {
    //         return actions.map(action => {
    //             const data: any = action.payload.doc.data();
    //             const id = data.id;
    //             return { id, ...data };
    //         });
    //     }));
    }

    /**
     * Change user's conversation present status to On / Decrease conversations badge count / Clear unread count
     * @param conversationID The conversation's id
     */
    public async enteredConversation(conversationID: string): Promise < any > {
        // const myID = await this.profileDispatch.getMyID();
        // return this.firestore.doc(`conversations/${conversationID}/members/${myID}`).update({
        //     status: 'on',
        //     lastReadTimestamp: new Date().getTime(),
        //     unreadCount: 0
        // }).then(async () => {
        //     return this.firestore.doc<any>(`users/${myID}`).get().toPromise().then(doc => {
        //         const user = doc.data();
        //         if (user == null) {
        //             throw new Error(`User doc ${myID} does not exist`);
        //         }
        //         if (user.badges && user.badges.conversations) {
        //             const unreadConversationIDs: Array < String > = user.badges.conversations;
        //             const index = unreadConversationIDs.indexOf(conversationID);
        //             if (index !== -1) {
        //                 unreadConversationIDs.splice(index, 1);
        //             }
        //             this.firestore.doc(`users/${myID}`).update({
        //                 'badges.conversations': unreadConversationIDs
        //             });
        //         }
        //     });
        // });
    }

    /**
     * Change user's conversation present status to Off
     * @param conversationID The conversation's id
     */
    public async leftConversation(conversationID: string): Promise < any > {
    //     const myID = await this.profileDispatch.getMyID();
    //     return this.firestore.doc(`conversations/${conversationID}/members/${myID}`).update({
    //         status: 'off'
    //     });
    }
}
